import { useState } from "react";

export default function ContentField({ k, label, defaultVal, currentVal, onSave, onReset }) {
  const [val, setVal] = useState(currentVal);
  const isLong = (defaultVal || "").length > 80;
  const dirty = val !== currentVal;
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-start py-3 border-t border-white/5 first:border-t-0">
      <div className="md:col-span-3 pt-2">
        <p className="text-sm text-zinc-300">{label}</p>
        <p className="text-[10px] text-zinc-600 font-mono mt-1">{k}</p>
      </div>
      <div className="md:col-span-7">
        {isLong
          ? <textarea rows={4} className="input-field" value={val} onChange={(e) => setVal(e.target.value)} data-testid={`content-input-${k}`} />
          : <input className="input-field" value={val} onChange={(e) => setVal(e.target.value)} data-testid={`content-input-${k}`} />}
      </div>
      <div className="md:col-span-2 flex gap-2">
        <button onClick={() => onSave(k, val)} disabled={!dirty}
          data-testid={`content-save-${k}`}
          className={`!py-2 !px-3 text-xs ${dirty ? "btn-lilac" : "btn-ghost opacity-50 cursor-not-allowed"}`}>Guardar</button>
        <button onClick={() => { setVal(defaultVal); onReset(k); }}
          data-testid={`content-reset-${k}`}
          className="btn-ghost !py-2 !px-3 text-xs">↺</button>
      </div>
    </div>
  );
}
